
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useIsMobile } from '@/hooks/use-mobile';
import CategorySidebar from './CategorySidebar';

interface LayoutProps {
  children: React.ReactNode;
  hideSidebar?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideSidebar = false }) => {
  const isMobile = useIsMobile();
  
  // Calculate the navbar height based on mobile or desktop
  const navbarHeight = isMobile ? '110px' : '76px';

  return (
    <div className="flex flex-col min-h-screen w-full max-w-full overflow-x-hidden">
      {/* Navbar with highest z-index */}
      <Navbar />
      
      {/* Main content area with sidebar */}
      <div className="flex flex-grow w-full relative" style={{ paddingTop: navbarHeight }}>
        {/* Fixed sidebar on desktop */}
        {!isMobile && !hideSidebar && (
          <div className="fixed left-0 top-[76px] w-64 z-[150]" 
               style={{ 
                 height: `calc(100vh - 76px)` 
               }}>
            <CategorySidebar className="h-full" />
          </div>
        )}
        
        {/* Main content with padding to accommodate sidebar */}
        <main className={`flex-grow ${!isMobile && !hideSidebar ? 'pl-64' : ''} w-full relative z-10`}>
          {children}
        </main>
      </div>
      
      <Footer />
    </div>
  );
};

export default Layout;
